import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ROUTES } from "../routes";

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-grey-80 dark:border-grey-30 mt-auto">
      <div className="px-4 py-4 lg:px-10 flex flex-col items-center justify-between gap-2 text-sm text-grey-50 dark:text-grey-70 sm:flex-row">
        <p>
          © {year} timeplanned · {t("footer.operatedBy")}{" "}
          <a
            href="https://cquelle.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-grey-20 dark:hover:text-white transition-colors"
          >
            CQUELLE GmbH
          </a>
        </p>
        <div className="flex items-center gap-5">
          <Link
            to={ROUTES.TERMS_OF_SERVICE}
            className="hover:text-grey-20 dark:hover:text-white transition-colors"
          >
            {t("auth.termsOfService", "Terms of Service")}
          </Link>
          <Link
            to={ROUTES.PRIVACY_POLICY}
            className="hover:text-grey-20 dark:hover:text-white transition-colors"
          >
            {t("auth.privacyPolicy", "Privacy Policy")}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
